import { IApiRequest } from "../types";
import { REQUEST_TYPE_ENUM } from "./constants";

import httpService from "./http-service";

export default function chooseRequest({ requestType }: IApiRequest): (request: IApiRequest) => Promise<unknown> {
  switch (requestType) {
    case REQUEST_TYPE_ENUM.HTTP:
      return httpService;
    default:
      return httpService;
  }
}
